import { getApiBaseUrl, getApiClient } from './serviceconfig';

const apiBaseUrl = getApiBaseUrl();

export async function getPurchaseDebitNoteNumber(cookies, plantId, dnDate) {
    const url = `${apiBaseUrl}/purchase_debit_notes/purchase_debit_note_number/?plant_id=${plantId}&dn_date=${dnDate}`;
    return getApiClient(cookies).get(url).then((r) => r.data);
}

export async function getPurchaseDebitNotes(cookies, params = {}) {
    const query = new URLSearchParams(params).toString();
    return getApiClient(cookies).get(`${apiBaseUrl}/purchase_debit_notes/${query ? `?${query}` : ''}`).then((r) => r.data);
}

export async function getPurchaseDebitNoteDetails(cookies, id) {
    return getApiClient(cookies).get(`${apiBaseUrl}/purchase_debit_notes/${id}/`).then((r) => r.data);
}

export async function printPurchaseDebitNote(cookies, noteId) {
    return getApiClient(cookies).get(`${apiBaseUrl}/purchase_debit_notes/${noteId}/print_purchase_debit_note/`, {
        responseType: 'blob',
    }).then((response) => response.data);
}

export async function getGrnsForPurchaseDebitNote(cookies, plantId, vendorId) {
    const url = `${apiBaseUrl}/purchase_debit_notes/grns_for_vendor/?plant_id=${plantId}&vendor_id=${vendorId}`;
    return getApiClient(cookies).get(url).then((r) => r.data);
}

export async function getPurchaseDebitNoteGrnContext(cookies, gmrId) {
    return getApiClient(cookies).get(`${apiBaseUrl}/purchase_debit_notes/grn_context/?gmr_id=${gmrId}`).then((r) => r.data);
}

export function createPurchaseDebitNote(cookies, payload) {
    return getApiClient(cookies).post(`${apiBaseUrl}/purchase_debit_notes/`, payload).then((r) => r.data);
}

export function cancelPurchaseDebitNote(cookies, id) {
    return getApiClient(cookies).patch(`${apiBaseUrl}/purchase_debit_notes/${id}/`, {}).then((r) => r.data);
}

export function deletePurchaseDebitNote(cookies, id) {
    return getApiClient(cookies).delete(`${apiBaseUrl}/purchase_debit_notes/${id}/`).then((r) => r.data);
}
